import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  public lastEmail = 'lastEmail';
  public data: {
    login: {
      lastEmail: 'lastEmail'
    }
  };
  constructor(private storage: Storage) { }

  async dataGet(data: string) {
    return await this.storage.get(data);
  }

  async dataSet(data: string, value: any) {
    return await this.storage.set(data, value);
  }

  async setObject(key: string, value: any) {
    return await this.storage.set(key, JSON.stringify(value));
  }

  async getObject(key: string) {
    const ret = await this.storage.get(key);
    return await JSON.parse(ret);
  }

  async emailLastGet() {
    return await this.storage.get(this.lastEmail);
  }

  async emailLastSet(email: string) {
    await this.storage.set(this.lastEmail, email);
  }

  clearFormatPhone(phone: string): string {
    let pTemp = '';
    pTemp = phone.replace(/[&\/\\#,()$~%.'":*?<>{}]/g, '');
    pTemp = pTemp.replace(/\s/g, '');
    console.log(pTemp);
    if ('+52' === pTemp.substring(0, 3)) {
      if (pTemp.length > 13) {
        pTemp = '+52' + pTemp.substr(pTemp.length - 10);
      }
    } else if (pTemp.length >= 10 && pTemp.substring(0, 1) !== '+') {
      pTemp = '+52' + pTemp.substr(pTemp.length - 10);
    }
    return pTemp;
  }
}
